<template>
  <Page class="detailView">
    <div class="pageContent-title">反馈详情</div>
    <div class="detailView-with-actions mt-5">
      <a-form class="flex-form form-label-6" :form="form" :colon="false" labelAlign="left">
        <!-- NOTE 字典使用 -->
        <a-form-item label="反馈类型">
          <a-select
            class="form-control"
            :options="fukuanleixing"
            v-decorator="[
              'type',
              {
                rules: [{ required: true, message: '请选择' }],
              },
            ]"
            placeholder="请选择"
          ></a-select>
        </a-form-item>
        <a-form-item label="反馈内容">
          <a-textarea
            v-decorator="[
              'content',
              {
                rules: [{ required: true, message: '请输入' }],
              },
            ]"
            :auto-size="{ minRows: 10, maxRows: 20 }"
          ></a-textarea>
        </a-form-item>
        <a-form-item label="是否受理">
          <a-radio-group
            v-decorator="[
              'status',
              {
                rules: [{ required: true, message: '请选择' }],
              },
            ]"
          >
            <a-radio v-for="(item, index) in typesMap.status" :value="item.value" :key="index">
              {{ item.label }}
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea
            v-decorator="[
              'remark',
              {
                rules: [{ required: true, message: '请选择' }],
              },
            ]"
            :auto-size="{ minRows: 10, maxRows: 20 }"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </div>

    <div class="detailView-actions">
      <a-button class="app-btn condition-btns" type="primary" @click="doSave">保存</a-button>
    </div>
  </Page>
</template>
<script>
import Page from '@/components/Page'
import { toolMixin } from '@/utils/mixin'
export default {
  components: {
    Page,
  },
  props: {},
  mixins: [toolMixin],
  data() {
    return {
      form: this.$form.createForm(this),
    }
  },
  computed: {
    fukuanleixing() {
      return this.$collection('fankuileixing').map(item => {
        // 后台存的Number类型，转换一下
        return { value: Number(item.value), label: item.label }
      })
    },
    typesMap() {
      return {
        status: [
          { value: 1, label: '未受理' },
          { value: 2, label: '已受理' },
        ],
      }
    },
  },
  methods: {
    doSave() {
      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          const params = values
          // const toCountry = this.countryList.find(item => item.value === params.toCountryId)?.label
          const id = this.$route.query.feedbackId
          try {
            const actionUrl = id ? '/operation-web-api/admin/feedback/answer' : '/operation-web-api/web/feedback/create'
            await this.$axios.post(actionUrl, {
              data: {
                feedbackId: id,
                ...params,
              },
            })
            this.$message.success('操作成功!')
            this.$router.go(-1)
          } catch (e) {
            console.error(e)
          }
        }
      })
    },
    async loadById(id) {
      const res = await this.$axios.post('/operation-web-api/admin/feedback/queryById', {
        data: id,
      })
      const feedbackData = res.data
      this.safeSetFieldsValue$t(this.form, { ...feedbackData })
    },
  },
  async mounted() {
    const id = this.$route.query.feedbackId
    if (id) {
      this.loadById(id)
    }
  },
}
</script>
<style scoped lang="less"></style>
